module.exports = require("node:fs/promises");